import Crono from "assets/img/crono.svg";
import CronoRed from "assets/img/crono-red.svg";
import { memo, useEffect, useState } from "react";
import getTimerWorker from "./timer-worker.factory.mjs";
import { QuestionsAll } from "./components/QuestionsAll";
import { ImgCrono } from "./components/ImgCrono";

interface ITimerProps {
  isScroll: boolean;
  allQuestion: number;
  question: number;
  remainingTime: number;
  isMinorTablet: boolean;
  isMinorMobile: boolean;
  isOpenTwoMinutes: boolean;
  setIsOpenTwoMinutes: (value: boolean) => void;
  handleOpenTimeFinishModal: () => void;
  handleOpenTwoMinutesModal: () => void;
}

const Timer = memo(
  ({
    isScroll,
    remainingTime,
    allQuestion,
    question,
    isMinorTablet,
    isMinorMobile,
    isOpenTwoMinutes,
    setIsOpenTwoMinutes,
    handleOpenTimeFinishModal,
    handleOpenTwoMinutesModal,
  }: ITimerProps) => {
    const [time, setTime] = useState<string>("");
    const [worker, setWorker] = useState<Worker | null>(null);
    const [isTimerZero, setIsTimerZero] = useState<boolean>(false);
    const [isSendFinishModalOpen, setIsSendFinishModalOpen] =
      useState<boolean>(false);
    const formatTime = (seconds: number): string => {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(remainingSeconds).padStart(2, "0")}`;
    };

    useEffect(() => {
      if (isTimerZero && !isSendFinishModalOpen) {
        handleOpenTimeFinishModal();
        setIsSendFinishModalOpen(true);
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTimerZero, handleOpenTimeFinishModal]);

    useEffect(() => {
      setTime(formatTime(remainingTime));
    }, [remainingTime]);

    useEffect(() => {
      let activeTwoMinutes = false;
      const newWorker = getTimerWorker();
      setWorker(newWorker);

      newWorker.onmessage = (e: MessageEvent<string>) => {
        setTime(e.data);
        if (e.data === formatTime(120)) {
          handleOpenTwoMinutesModal();
        }
        if (e.data <= formatTime(300) && !activeTwoMinutes) {
          activeTwoMinutes = true;
          setIsOpenTwoMinutes(true);
        }
        if (e.data === formatTime(0)) {
          stopCountdown();
          setIsTimerZero(true);
        }
      };

      newWorker.postMessage({ command: "start", duration: remainingTime });

      return () => {
        newWorker.terminate();
      };

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [remainingTime]);

    const stopCountdown = () => {
      if (worker) {
        worker.postMessage({ command: "stop" });
      }
    };

    const divContainer = `flex  ${isScroll ? 'w-full' : 'w-230'} items-center ${
      isMinorTablet && !isScroll ? "gap-2 justify-center mb-4" : "gap-5"
    }`;
    const sizeImg = ` ${isOpenTwoMinutes ? "text-red-60" : "text-neutral-02"} ${
      isMinorTablet ? "w-12" : ""
    } ${isScroll ? 'hidden' : ''}`;
    const sizeTextTime = `font-bold text-color-02 ${
      isMinorTablet ? "text-small-02" : "text-subheading-02"
    } ${isScroll ? 'hidden' : ''}`;
    const marginSize = ` ${isScroll ? 'flex' : ''} text-color-02 ${isMinorTablet ? "" : !isScroll && "mt-3"}`;

    return (
      <div className={divContainer}>
        <ImgCrono url={isOpenTwoMinutes ? CronoRed : Crono} className={sizeImg}/>
        <div className={marginSize}>
          <p className={sizeTextTime} data-testid="time-not-scroll">Tiempo de examen </p>
          <span
            className={`text-heading-01 duration-300 ease-in-out ${
              isOpenTwoMinutes ? "text-red-60" : "text-color-02"
            } ${isScroll ? 'hidden' : ''}`}
          >
            {time}
          </span>
        </div>
        <div className={`items-center ${isMinorMobile ? 'justify-center' : 'justify-between'}  w-full flex-wrap ${isScroll ? 'flex  ' : 'hidden'}`}>
          <div className="flex items-center">
            <ImgCrono url={isOpenTwoMinutes ? CronoRed : Crono} className="w-11"/>
            <div className={marginSize}>
              <p className="text-subheading-02 ml-2 font-bold" data-testid="time-scroll">Tiempo de examen: </p>
              <span
                className={`text-subheading-01 font-black ml-1 duration-300 ease-in-out    ${
                  isOpenTwoMinutes ? "text-red-60" : "text-color-02"
                }`}
                style={{
                  marginTop: '-2px'
                }}
              >
                {time}
              </span>
            </div>
          </div>
          <QuestionsAll isMinorMobile={isMinorMobile} allQuestion={allQuestion} questionNow={question - 1} />
        </div>
      </div>
    );
  }
);

export default Timer;
